let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("itvKG")).then(() => parcelRequire('8RrFV'));